import { render, staticRenderFns } from "./fund-discrete-and-periodic-performance-table-panel.vue?vue&type=template&id=943fa55a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports